'use client'

import { usePathname } from 'next/navigation'
import Sidebar from '@/components/Sidebar'
import Header from '@/components/Header'
import { useTheme } from '@/theme/ThemeContext'

const PUBLIC_PATHS = ['/login']

export default function AppShell({ children }: { children: React.ReactNode }) {
    const { theme, toggleTheme } = useTheme();
  const pathname = usePathname()
  const isPublic = PUBLIC_PATHS.some(p => pathname === p || pathname.startsWith(p + '/'))

  if (isPublic) return <>{children}</>

  return (
    <>
      <header className="shrink-0 z-40 bg-white border-b border-slate-200 shadow-xs">
        <Header />
      </header>

      <div className="flex flex-1 bg-white min-h-0 overflow-hidden relative">
        <Sidebar />
        <main className={`flex-1 flex flex-col min-w-0 overflow-y-auto ${theme==='light'?' bg-slate-50':'bg-slate-100/90'} p-6 md:p-8 md:ml-64`}>
          <div className="max-w-7xl w-full mx-auto space-y-6">
            {children}
          </div>
        </main>
      </div>
    </>
  )
}
